import styled from 'styled-components';
import { Input } from 'antd';

const { TextArea } = Input;

export const TextAreaStyle = styled(TextArea)``;
